/* istanbul ignore file */
import { useParams } from 'react-router-dom';
import BudgetBreadcrumbs from 'domain/finance/budget/shared/BudgetBreadcrumbs';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useBudgetUrl } from 'domain/shared/budget';
import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';

const SingleBudgetBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getSingleEntityUrl } = useBudgetUrl();
  const { id = '' } = useParams<Dictionary<string>>();

  return (
    <BudgetBreadcrumbs>
      <SingleBreadcrumbItem entity={id} link={getSingleEntityUrl(id)} />
      {children}
    </BudgetBreadcrumbs>
  );
};

export default SingleBudgetBreadcrumbs;
